module.exports = __webpack_public_path__ + "media/images/login_as_icon2-98239a46cb4860817e2c38ae77b821b8.gif";